import React from 'react';
import { FlameIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function StickyAnnouncementBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-pink-600 text-white py-3 px-4 shadow-lg" data-id="element-195">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 flex-wrap text-center" data-id="element-196">
        <FlameIcon className="w-5 h-5 flex-shrink-0" data-id="element-197" />
        <span className="font-bold text-sm md:text-base" data-id="element-198">
          ÚLTIMOS CUPOS CON 50% OFF + 10 BONOS GRATIS
        </span>
        <FlameIcon className="w-5 h-5 flex-shrink-0" data-id="element-199" />
        <div className="hidden md:block ml-2" data-id="element-200">
          <CountdownTimer compact data-id="element-201" />
        </div>
      </div>
    </div>;
}